import React, { Dispatch, useReducer } from 'react';
import SellerListingCardContext from './SellerListingCardContext';
import SellerListingCard from './SellerListingCard';
import { CoreMyListingsFetchListing, Listing } from '@reverbdotcom/commons/src/rql';
import { RCToast } from '@reverbdotcom/cadence/components';
import listingCardReducer, { ICardState } from './sellerListingCardReducer';
import { FETCH_LISTING_QUERY } from './SellerListingCardsCollection';
import { useLazyQuery } from '@reverbdotcom/commons/src/useLazyQuery';

interface IExternalProps {
  defaultListing: Listing;
}
interface IListingUpdatedToastProps {
  cardState: ICardState;
  dispatch: Dispatch<any>;
}

function ListingUpdatedToast({ cardState, dispatch }: IListingUpdatedToastProps) {
  return <RCToast
    delayInterval="short"
    onClose={() => {
      dispatch({
        type: 'hideToast',
      });
    }}
    text={cardState.toast?.message}
    theme={cardState.toast?.isSuccess ? 'success' : 'error'}
    isOpen={cardState.toast?.isOpen}
  />;
}

function SellerListingCardContainer({
  defaultListing,
}: IExternalProps) {
  const listingQuery = useLazyQuery<CoreMyListingsFetchListing.Query, CoreMyListingsFetchListing.Variables>(
    FETCH_LISTING_QUERY,
    {
      variables: {
        id: defaultListing.id,
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  const initialCardState = {
    loadingListing: false,
    listing: defaultListing,
    toast: {
      isOpen: false,
      message: '',
      isSuccess: true,
    },
  };

  const [cardState, dispatch] = useReducer(
    listingCardReducer,
    initialCardState,
  );

  return (
    <>
      <SellerListingCardContext.Provider
        value={{
          cardState,
          dispatch,
          listingQuery,
        }}
      >
        <SellerListingCard listing={cardState.listing}/>
      </SellerListingCardContext.Provider>
      <ListingUpdatedToast
        cardState={cardState}
        dispatch={dispatch}
      />
    </>
  );
}

export default SellerListingCardContainer;
